import { useState, useEffect, useRef } from 'react';

interface Question {
  question: string;
  options: string[];
  correct: number;
}

const QUESTIONS: Question[] = [
  { question: "Khi bất đồng ý kiến xảy ra trong lúc chơi, điều quan trọng nhất để giải quyết vấn đề là gì?", options: ["Cố gắng giành phần thắng", "Hiểu và lắng nghe nhau", "Giữ im lặng hoàn toàn", "Tránh mặt nhau"], correct: 1 },
  { question: "Hành động nào dưới đây KHÔNG phù hợp khi hòa giải mâu thuẫn?", options: ["Lắng nghe bạn", "Nhường nhịn", "Nói nhẹ nhàng", "La hét lớn tiếng"], correct: 3 },
  { question: "Khi bạn vô tình va vào em trong lúc chơi và làm em khó chịu, em nên chọn cách ứng xử nào phù hợp nhất?", options: ["Đẩy lại bạn ngay lập tức", "Khóc to để mọi người chú ý", "Nói \"không sao\" và tiếp tục chơi", "Mắng bạn vì đã bất cẩn"], correct: 2 },
  { question: "Khi chơi theo nhóm, điều nào giúp hạn chế tranh chấp nhất?", options: ["Hợp tác và vui vẻ", "Giành phần thắng", "Hơn thua", "Tranh giành"], correct: 0 },
  { question: "Khi xảy ra tranh chấp trong lúc chơi cùng các bạn, em nên làm gì trước tiên để tránh mâu thuẫn trở nên nghiêm trọng hơn?", options: ["La hét thật to để mọi người chú ý", "Giữ bình tĩnh và suy nghĩ cách giải quyết", "Bỏ đi ngay lập tức", "Khóc để được giúp đỡ"], correct: 1 },
  { question: "Hành động nào giúp giải quyết mâu thuẫn hiệu quả nhất?", options: ["Nói chuyện để hiểu nhau", "Cãi nhau", "Đánh nhau", "Bỏ chạy"], correct: 0 },
  { question: "Việc hòa giải khi xảy ra mâu thuẫn trong trò chơi sẽ mang lại kết quả như thế nào?", options: ["Làm mọi người buồn hơn", "Khiến các bạn xa nhau", "Giúp mọi người vui vẻ trở lại", "Làm mọi người sợ hãi"], correct: 2 },
  { question: "Khi bạn đã xin lỗi sau mâu thuẫn, em nên làm gì?", options: ["Tha thứ", "Im lặng", "Giận tiếp", "Mắng lại"], correct: 0 },
  { question: "Khi tham gia chơi cùng nhiều bạn trong lớp, em cần thực hiện điều gì để trò chơi diễn ra vui vẻ và ít xảy ra tranh chấp?", options: ["Luôn giành phần hơn cho mình", "Dễ giận dỗi khi không vừa ý", "Bỏ đi khi không thích", "Biết hợp tác và chia sẻ với bạn"], correct: 3 },
  { question: "Khi bạn buồn vì tranh chấp, em nên làm gì?", options: ["Cười", "Bỏ đi", "An ủi", "Trêu chọc"], correct: 2 },
  { question: "Khi xảy ra tranh chấp trong lúc chơi, việc giữ bình tĩnh và nói chuyện nhẹ nhàng sẽ giúp giải quyết mâu thuẫn hiệu quả hơn.", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Trong các câu nói sau, câu nào thể hiện rõ hành động hòa giải khi xảy ra mâu thuẫn trong trò chơi?", options: ["\"Chúng mình cùng tìm cách chơi cho vui nhé!\"", "\"Tớ không chơi với cậu nữa đâu!\"", "\"Cậu sai rồi, phải nghe tớ!\"", "\"Tớ thắng rồi nên không cần nói nữa!\""], correct: 0 },
  { question: "Khi bạn không chịu chia sẻ đồ chơi với em trong lúc chơi chung, em nên làm gì để giải quyết tình huống phù hợp?", options: ["Nói chuyện nhẹ nhàng để thỏa thuận", "Giật lấy đồ chơi từ tay bạn", "Khóc để người lớn can thiệp", "Đánh bạn để lấy lại đồ chơi"], correct: 0 },
  { question: "Khi xảy ra hiểu lầm trong lúc chơi, em nên làm gì để giải quyết?", options: ["Giận", "Tránh mặt", "Hỏi lại để làm rõ", "Mắng bạn"], correct: 2 },
  { question: "Khi tham gia hòa giải, điều quan trọng nhất là gì?", options: ["Nóng giận", "Né tránh", "Cãi nhau", "Bình tĩnh"], correct: 3 },
  { question: "Khi bạn và em cùng muốn sử dụng một món đồ chơi trong cùng một thời điểm, tình huống này được gọi là gì?", options: ["Sự hợp tác vui vẻ", "Hoạt động giúp đỡ", "Sự chia sẻ tự nhiên", "Tình huống tranh chấp"], correct: 3 },
  { question: "Khi chơi cùng các bạn, điều nào dưới đây là quan trọng nhất để duy trì sự vui vẻ?", options: ["Luôn hơn thua", "Cùng nhau vui chơi", "Tranh giành", "Giận dỗi"], correct: 1 },
  { question: "Khi không đồng ý với bạn trong trò chơi, em nên la hét thật to để bạn phải nghe theo ý kiến của mình.", options: ["Đúng", "Sai"], correct: 1 },
  { question: "Nhường nhịn bạn trong một số tình huống khi chơi có thể giúp cả hai cùng vui vẻ hơn.", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Khi xảy ra tranh chấp, em có thể giải quyết bằng cách đánh bạn để giành phần thắng nhanh hơn.", options: ["Đúng", "Sai"], correct: 1 },
  { question: "Khi nhóm bạn xảy ra bất đồng ý kiến, em nên làm gì để giúp mọi người tiếp tục chơi vui vẻ?", options: ["Bỏ đi", "Cùng nhau bàn bạc", "Cãi nhau", "Im lặng"], correct: 1 },
  { question: "Vì sao cần hòa giải khi xảy ra tranh chấp trong lúc chơi?", options: ["Để giành phần thắng", "Để mọi người cùng vui vẻ", "Để chứng minh mình đúng", "Để kết thúc trò chơi"], correct: 1 },
  { question: "Khi bạn làm sai luật trong lúc chơi khiến em không hài lòng, em nên chọn cách ứng xử nào phù hợp nhất?", options: ["Đánh bạn để bạn nhớ lâu", "Nói chuyện nhẹ nhàng để bạn hiểu", "Bỏ mặc bạn và không chơi nữa", "Mắng bạn trước mặt mọi người"], correct: 1 },
  { question: "Việc lắng nghe ý kiến của bạn trong lúc xảy ra bất đồng sẽ giúp em hiểu rõ vấn đề hơn.", options: ["Đúng", "Sai"], correct: 0 },
  { question: "Khi bạn không đồng ý với ý kiến của em, em nên làm gì để tránh mâu thuẫn?", options: ["Ép bạn làm theo", "Lắng nghe và trao đổi", "Bỏ đi", "Giận dỗi"], correct: 1 },
];

const OPTION_LABELS = ['A', 'B', 'C', 'D'];
const TEAM1_KEYS = ['a', 'w', 's', 'z'];
const TEAM2_KEYS = ['k', 'i', 'j', 'm'];
const GAME_DURATION = 300;

function saveAchievement(data: object) {
  try {
    const key = 'bahnar_achievements';
    const existing = JSON.parse(localStorage.getItem(key) || '[]');
    existing.unshift({ ...data, date: new Date().toLocaleDateString('vi-VN') });
    localStorage.setItem(key, JSON.stringify(existing.slice(0, 50)));
  } catch (_) { /* ignore */ }
}

const KEOCO_MUSIC_URL = 'https://storage.readdy-site.link/project_files/d941aef1-6212-4727-9a5e-0c38b2f72f78/41df9622-081a-4483-a39a-1e36c19f1032_music_for_videos-energetic-uplifting-pop-110058.mp3?v=b41cb13ee3262ed893893126a0e31224';

function useGameMusic(playing: boolean, muted: boolean) {
  const audioRef = useRef<HTMLAudioElement | null>(null);

  useEffect(() => {
    const audio = new Audio(KEOCO_MUSIC_URL);
    audio.loop = true;
    audio.volume = 0.4;
    audioRef.current = audio;
    return () => {
      audio.pause();
      audioRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!audioRef.current) return;
    if (playing && !muted) {
      audioRef.current.play().catch(() => {});
    } else {
      audioRef.current.pause();
    }
  }, [playing, muted]);
}

function playAlarmBeepSingle() {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    const ctx = new AudioCtx();
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.connect(g); g.connect(ctx.destination);
    osc.type = 'square';
    osc.frequency.value = 1100;
    const t = ctx.currentTime;
    g.gain.setValueAtTime(0.4, t);
    g.gain.exponentialRampToValueAtTime(0.001, t + 0.35);
    osc.start(t); osc.stop(t + 0.4);
    setTimeout(() => ctx.close(), 800);
  } catch (_) { /* ignore */ }
}

function Fireworks() {
  const items = ['🎉', '🎊', '✨', '🌟', '⭐', '💫', '🎆', '🎇'];
  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {[...Array(24)].map((_, i) => (
        <div
          key={i}
          className="absolute text-3xl"
          style={{
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 90}%`,
            fontSize: `${1.2 + Math.random() * 1.6}rem`,
            animation: `bounce 0.6s ease-out ${i * 0.08}s both`,
          }}
        >
          {items[i % items.length]}
        </div>
      ))}
    </div>
  );
}

function playAnswerSound(correct: boolean) {
  try {
    const AudioCtx = window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext;
    const ctx = new AudioCtx();
    if (correct) {
      // Ascending cheerful chime
      const freqs = [523, 659, 784, 1047];
      freqs.forEach((freq, i) => {
        const osc = ctx.createOscillator();
        const g = ctx.createGain();
        osc.connect(g); g.connect(ctx.destination);
        osc.type = 'sine';
        osc.frequency.value = freq;
        const t = ctx.currentTime + i * 0.08;
        g.gain.setValueAtTime(0, t);
        g.gain.linearRampToValueAtTime(0.28, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.001, t + 0.22);
        osc.start(t); osc.stop(t + 0.25);
      });
      setTimeout(() => ctx.close(), 1200);
    } else {
      // Descending wrong buzz
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.connect(g); g.connect(ctx.destination);
      osc.type = 'sawtooth';
      osc.frequency.setValueAtTime(280, ctx.currentTime);
      osc.frequency.exponentialRampToValueAtTime(140, ctx.currentTime + 0.35);
      g.gain.setValueAtTime(0.3, ctx.currentTime);
      g.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.38);
      osc.start(ctx.currentTime); osc.stop(ctx.currentTime + 0.4);
      setTimeout(() => ctx.close(), 800);
    }
  } catch (_) { /* ignore */ }
}

export default function KeoCoGame({ onBack }: { onBack: () => void }) {
  const [t1QIdx, setT1QIdx] = useState(0);
  const [t2QIdx, setT2QIdx] = useState(1);
  const [t1Selected, setT1Selected] = useState<number | null>(null);
  const [t2Selected, setT2Selected] = useState<number | null>(null);
  const [t1ShowResult, setT1ShowResult] = useState(false);
  const [t2ShowResult, setT2ShowResult] = useState(false);
  const [t1Locked, setT1Locked] = useState(false);
  const [t2Locked, setT2Locked] = useState(false);
  const [timeLeft, setTimeLeft] = useState(GAME_DURATION);
  const [team1Score, setTeam1Score] = useState(0);
  const [team2Score, setTeam2Score] = useState(0);
  const [team1Errors, setTeam1Errors] = useState(0);
  const [team2Errors, setTeam2Errors] = useState(0);
  const [phase, setPhase] = useState<'playing' | 'result'>('playing');
  const [winner, setWinner] = useState<1 | 2 | 'draw' | null>(null);
  const [saved, setSaved] = useState(false);
  const [showFireworks, setShowFireworks] = useState(false);
  const [pressedKey, setPressedKey] = useState<string | null>(null);
  const [muted, setMuted] = useState(false);

  const q1 = QUESTIONS[t1QIdx % QUESTIONS.length];
  const q2 = QUESTIONS[t2QIdx % QUESTIONS.length];

  useGameMusic(phase === 'playing', muted);

  const ropeOffset = Math.max(-90, Math.min(90, (team2Errors - team1Errors) * 20));
  const isUrgent = timeLeft <= 5;

  const handleRestart = () => {
    setT1QIdx(0);
    setT2QIdx(1);
    setT1Selected(null);
    setT2Selected(null);
    setT1ShowResult(false);
    setT2ShowResult(false);
    setT1Locked(false);
    setT2Locked(false);
    setTimeLeft(GAME_DURATION);
    setTeam1Score(0);
    setTeam2Score(0);
    setTeam1Errors(0);
    setTeam2Errors(0);
    setPhase('playing');
    setWinner(null);
    setSaved(false);
    setShowFireworks(false);
    setPressedKey(null);
  };

  // Timer
  useEffect(() => {
    if (phase !== 'playing') return;
    if (timeLeft <= 0) {
      // Win by higher score
      const w: 1 | 2 | 'draw' = team1Score > team2Score ? 1 : team2Score > team1Score ? 2 : 'draw';
      setWinner(w);
      setShowFireworks(true);
      setTimeout(() => { setShowFireworks(false); setPhase('result'); }, 3500);
      return;
    }
    if (timeLeft <= 5 && timeLeft > 0) {
      playAlarmBeepSingle();
    }
    const t = setTimeout(() => setTimeLeft(p => p - 1), 1000);
    return () => clearTimeout(t);
  }, [timeLeft, phase, team1Score, team2Score]);

  // Keyboard handler
  useEffect(() => {
    if (phase !== 'playing') return;
    const handleKey = (e: KeyboardEvent) => {
      const key = e.key.toLowerCase();
      setPressedKey(key);
      setTimeout(() => setPressedKey(null), 200);

      if (TEAM1_KEYS.includes(key) && !t1Locked) {
        const idx = TEAM1_KEYS.indexOf(key);
        if (idx >= q1.options.length) return;
        setT1Selected(idx);
        setT1Locked(true);
        const correct = idx === q1.correct;
        if (correct) {
          playAnswerSound(true);
          setTeam1Score(p => p + 10);
        } else {
          setTeam1Errors(p => p + 1);
        }
        setT1ShowResult(true);
        setTimeout(() => {
          setT1ShowResult(false);
          setT1Selected(null);
          setT1Locked(false);
          setT1QIdx(p => p + 2);
        }, 1200);
      } else if (TEAM2_KEYS.includes(key) && !t2Locked) {
        const idx = TEAM2_KEYS.indexOf(key);
        if (idx >= q2.options.length) return;
        setT2Selected(idx);
        setT2Locked(true);
        const correct = idx === q2.correct;
        if (correct) {
          playAnswerSound(true);
          setTeam2Score(p => p + 10);
        } else {
          setTeam2Errors(p => p + 1);
        }
        setT2ShowResult(true);
        setTimeout(() => {
          setT2ShowResult(false);
          setT2Selected(null);
          setT2Locked(false);
          setT2QIdx(p => p + 2);
        }, 1200);
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [phase, t1Locked, t2Locked, q1.correct, q2.correct, q1.options.length, q2.options.length]);

  const handleSave = () => {
    saveAchievement({ game: 'Kéo co', winner: winner === 'draw' ? 'Hòa' : `Đội ${winner === 1 ? 'Xanh' : 'Đỏ'}`, team1Score, team2Score });
    setSaved(true);
  };

  const mins = Math.floor(timeLeft / 60);
  const secs = timeLeft % 60;

  if (phase === 'result') {
    return (
      <div className="min-h-screen bg-gradient-to-b from-amber-50 via-orange-50 to-yellow-50 flex flex-col items-center justify-center px-6 py-12">
        {showFireworks && <Fireworks />}
        <div className="text-8xl mb-4 animate-bounce">{winner === 'draw' ? '🤝' : '🏆'}</div>
        <h2 className="text-4xl font-extrabold text-primary-brown-dark mb-2">
          {winner === 'draw' ? 'Hòa nhau!' : `Đội ${winner === 1 ? '🔵 Xanh' : '🔴 Đỏ'} thắng!`}
        </h2>
        <p className="text-primary-brown-light mb-8 text-center max-w-md text-lg">
          {winner === 'draw' ? 'Cả hai đội kéo đều tay nhau!' : `Đội ${winner === 1 ? 'Xanh' : 'Đỏ'} đã kéo mạnh hơn và giành chiến thắng!`}
        </p>
        <div className="flex gap-6 mb-8">
          <div className="bg-sky-50 rounded-3xl px-10 py-6 text-center border-2 border-sky-300">
            <div className="text-4xl mb-2">🔵</div>
            <p className="font-extrabold text-sky-700 text-3xl">{team1Score} điểm</p>
            <p className="text-sm text-sky-500 mt-1">Sai: {team1Errors} lần</p>
          </div>
          <div className="bg-red-50 rounded-3xl px-10 py-6 text-center border-2 border-red-300">
            <div className="text-4xl mb-2">🔴</div>
            <p className="font-extrabold text-red-600 text-3xl">{team2Score} điểm</p>
            <p className="text-sm text-red-400 mt-1">Sai: {team2Errors} lần</p>
          </div>
        </div>
        <div className="flex gap-4 flex-wrap justify-center">
          {!saved ? (
            <button onClick={handleSave} className="px-7 py-3 bg-gradient-to-r from-green-500 to-emerald-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
              <i className="ri-trophy-fill"></i> Lưu thành tích
            </button>
          ) : (
            <div className="px-7 py-3 bg-green-100 text-green-700 font-bold rounded-2xl flex items-center gap-2">
              <i className="ri-check-fill"></i> Đã lưu!
            </div>
          )}
          <button onClick={handleRestart} className="px-7 py-3 bg-gradient-to-r from-sky-500 to-sky-400 text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
            <i className="ri-restart-line"></i> Chơi lại
          </button>
          <button onClick={onBack} className="px-7 py-3 bg-gradient-to-r from-primary-orange to-primary-yellow text-white font-bold rounded-2xl cursor-pointer whitespace-nowrap flex items-center gap-2">
            <i className="ri-home-4-line"></i> Trở về Trang chủ trò chơi
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col relative" style={{
      minWidth: 768,
    }}>
      {/* Background image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=Bahnar%20ethnic%20highland%20village%20Vietnam%20traditional%20festival%20outdoor%20scene%20bamboo%20poles%20colorful%20woven%20fabric%20decorations%20lush%20green%20mountains%20tropical%20forest%20warm%20sunny%20day%20festive%20atmosphere%20watercolor%20soft%20illustration&width=1280&height=800&seq=keoco-bg-playing-v3&orientation=landscape)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Frosted overlay */}
      <div className="absolute inset-0 z-0 bg-white/58 backdrop-blur-sm" />

      {/* Content */}
      <div className="relative z-10 flex flex-col flex-1 min-h-screen">
      {/* Urgent alarm overlay */}
      {isUrgent && (
        <div className="fixed inset-0 pointer-events-none z-30"
          style={{ background: 'rgba(220,38,38,0.08)', animation: 'pulse 0.5s ease-in-out infinite alternate' }}>
          <div className="absolute inset-x-0 top-0 h-2 bg-red-500 animate-pulse"></div>
          <div className="absolute inset-x-0 bottom-0 h-2 bg-red-500 animate-pulse"></div>
        </div>
      )}

      {/* Decorative banner */}
      <div className="w-full py-1 text-center text-xs font-bold tracking-widest text-white relative"
        style={{ background: 'linear-gradient(90deg, #0ea5e9, #f97316, #ef4444)' }}>
        🔵 ĐỘI XANH &nbsp;&nbsp;⚔️&nbsp;&nbsp; KÉO CO BAHNAR &nbsp;&nbsp;⚔️&nbsp;&nbsp; ĐỘI ĐỎ 🔴
        {/* Mute button */}
        <button
          onClick={() => setMuted(m => !m)}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center bg-white/20 hover:bg-white/40 rounded-full transition-colors cursor-pointer"
          title={muted ? 'Bật tiếng' : 'Tắt tiếng'}
        >
          <i className={`${muted ? 'ri-volume-mute-fill' : 'ri-volume-up-fill'} text-white text-sm`}></i>
        </button>
      </div>

      {/* Timer + Score */}
      <div className={`px-6 py-3 flex items-center justify-between border-b-2 transition-all duration-300 ${isUrgent ? 'bg-red-100/90 border-red-500' : 'bg-white/70 border-white/40'}`}>
        {/* Team 1 score */}
        <div className="flex items-center gap-3 bg-sky-50/90 rounded-2xl px-5 py-2 border-2 border-sky-300">
          <div className="text-2xl">🔵</div>
          <div>
            <p className="text-xs text-sky-500 font-bold">Đội Xanh — Phím: A W S Z</p>
            <p className="text-xl font-extrabold text-sky-700">{team1Score} điểm</p>
          </div>
        </div>

        {/* Central timer */}
        <div className="text-center flex flex-col items-center">
          {isUrgent && (
            <div className="mb-1 px-4 py-1.5 bg-red-600 text-white font-extrabold rounded-full animate-pulse text-sm tracking-wider shadow-lg">
              🚨 SẮP KẾT THÚC!
            </div>
          )}
          <div className={`font-extrabold font-mono transition-all duration-200 ${
            isUrgent
              ? 'text-red-600 animate-pulse text-6xl scale-110'
              : 'text-primary-brown-dark text-4xl'
          }`}>
            {mins}:{secs.toString().padStart(2, '0')}
          </div>
          {!isUrgent && <p className="text-xs text-primary-brown-light mt-1">⏱ Thời gian còn lại</p>}
        </div>

        {/* Team 2 score */}
        <div className="flex items-center gap-3 bg-red-50/90 rounded-2xl px-5 py-2 border-2 border-red-300">
          <div className="text-right">
            <p className="text-xs text-red-400 font-bold">Đội Đỏ — Phím: K I J M</p>
            <p className="text-xl font-extrabold text-red-600">{team2Score} điểm</p>
          </div>
          <div className="text-2xl">🔴</div>
        </div>
      </div>

      {/* Split screen questions */}
      <div className="flex flex-1 min-h-0">
        {/* Team 1 */}
        <div className="flex-1 flex flex-col px-5 pt-4 pb-3"
          style={{ background: 'linear-gradient(180deg, rgba(224,242,254,0.75) 0%, rgba(255,255,255,0.45) 100%)' }}>
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-extrabold text-sky-700 flex items-center gap-2">
              <span className="text-2xl">🔵</span> Đội Xanh
            </h3>
            {t1ShowResult && (
              <span className={`text-sm font-bold px-3 py-1 rounded-full animate-bounce ${t1Selected === q1.correct ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                {t1Selected === q1.correct ? '✅ Đúng! +10đ' : '❌ Sai!'}
              </span>
            )}
          </div>

          <div className="bg-white/85 rounded-2xl p-4 flex-1 border border-sky-100">
            <div className="flex items-center gap-2 mb-3">
              <span className="text-xs bg-sky-100 text-sky-600 font-bold px-2 py-0.5 rounded-full">Câu #{Math.floor(t1QIdx / 2) + 1}</span>
              {t1Locked && !t1ShowResult && <span className="text-xs text-sky-500 animate-pulse">⏳ Đang xử lý...</span>}
            </div>
            <p className="text-base font-bold text-primary-brown-dark mb-3 leading-relaxed">{q1.question}</p>
            <div className="space-y-2">
              {q1.options.map((opt, idx) => {
                let cls = 'border-2 border-sky-200 bg-sky-50/50 text-primary-brown hover:border-sky-400';
                if (t1ShowResult) {
                  if (idx === q1.correct) cls = 'border-2 border-green-400 bg-green-50 text-green-700 font-bold';
                  else if (idx === t1Selected && idx !== q1.correct) cls = 'border-2 border-red-400 bg-red-50 text-red-600';
                  else cls = 'border-2 border-sky-100 bg-white/40 text-primary-brown-light';
                } else if (t1Selected === idx) cls = 'border-2 border-sky-500 bg-sky-100 text-sky-700 font-bold';
                const kp = pressedKey === TEAM1_KEYS[idx];
                return (
                  <div key={idx} className={`flex items-center gap-2 px-3 py-2 rounded-xl text-sm transition-all cursor-default ${cls} ${kp ? 'scale-95' : ''}`}>
                    <span className={`w-7 h-7 flex items-center justify-center rounded-lg font-extrabold text-xs flex-shrink-0 transition-colors ${kp ? 'bg-sky-500 text-white' : 'bg-sky-200 text-sky-700'}`}>
                      {OPTION_LABELS[idx]}
                    </span>
                    <span className="text-sm leading-tight flex-1">{opt}</span>
                    {t1ShowResult && idx === q1.correct && <i className="ri-check-line text-green-500 text-base flex-shrink-0"></i>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="w-1 bg-gradient-to-b from-sky-300 via-amber-300 to-red-300 flex-shrink-0"></div>

        {/* Team 2 */}
        <div className="flex-1 flex flex-col px-5 pt-4 pb-3"
          style={{ background: 'linear-gradient(180deg, rgba(254,226,226,0.75) 0%, rgba(255,255,255,0.45) 100%)' }}>
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-extrabold text-red-600 flex items-center gap-2">
              <span className="text-2xl">🔴</span> Đội Đỏ
            </h3>
            {t2ShowResult && (
              <span className={`text-sm font-bold px-3 py-1 rounded-full animate-bounce ${t2Selected === q2.correct ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'}`}>
                {t2Selected === q2.correct ? '✅ Đúng! +10đ' : '❌ Sai!'}
              </span>
            )}
          </div>

          <div className="bg-white/85 rounded-2xl p-4 flex-1 border border-red-100">
            <div className="flex items-center gap-2 mb-3">
              <span className="text-xs bg-red-100 text-red-500 font-bold px-2 py-0.5 rounded-full">Câu #{Math.floor(t2QIdx / 2) + 1}</span>
              {t2Locked && !t2ShowResult && <span className="text-xs text-red-400 animate-pulse">⏳ Đang xử lý...</span>}
            </div>
            <p className="text-base font-bold text-primary-brown-dark mb-3 leading-relaxed">{q2.question}</p>
            <div className="space-y-2">
              {q2.options.map((opt, idx) => {
                let cls = 'border-2 border-red-200 bg-red-50/50 text-primary-brown hover:border-red-400';
                if (t2ShowResult) {
                  if (idx === q2.correct) cls = 'border-2 border-green-400 bg-green-50 text-green-700 font-bold';
                  else if (idx === t2Selected && idx !== q2.correct) cls = 'border-2 border-red-400 bg-red-50 text-red-600';
                  else cls = 'border-2 border-red-100 bg-white/40 text-primary-brown-light';
                } else if (t2Selected === idx) cls = 'border-2 border-red-500 bg-red-100 text-red-700 font-bold';
                const kp = pressedKey === TEAM2_KEYS[idx];
                return (
                  <div key={idx} className={`flex items-center gap-2 px-3 py-2 rounded-xl text-sm transition-all cursor-default ${cls} ${kp ? 'scale-95' : ''}`}>
                    <span className={`w-7 h-7 flex items-center justify-center rounded-lg font-extrabold text-xs flex-shrink-0 transition-colors ${kp ? 'bg-red-500 text-white' : 'bg-red-200 text-red-700'}`}>
                      {OPTION_LABELS[idx]}
                    </span>
                    <span className="text-sm leading-tight flex-1">{opt}</span>
                    {t2ShowResult && idx === q2.correct && <i className="ri-check-line text-green-500 ml-auto text-base flex-shrink-0"></i>}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Rope bar - redesigned: solid blue/red, no characters */}
      <div className={`px-6 py-5 transition-all duration-300 ${isUrgent ? 'bg-red-50/80' : 'bg-white/20'}`}>
        <div className="relative h-16 rounded-2xl overflow-hidden flex" style={{ boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.15)' }}>
          {/* Blue side */}
          <div className="flex-1 flex items-center pl-6"
            style={{ background: 'linear-gradient(135deg, #0ea5e9, #38bdf8)' }}>
            <span className="text-white font-extrabold text-lg drop-shadow">← XANH</span>
          </div>
          {/* Red side */}
          <div className="flex-1 flex items-center justify-end pr-6"
            style={{ background: 'linear-gradient(135deg, #f87171, #ef4444)' }}>
            <span className="text-white font-extrabold text-lg drop-shadow">ĐỎ →</span>
          </div>
          {/* Center marker */}
          <div
            className="absolute top-0 bottom-0 w-5 bg-white flex items-center justify-center transition-all duration-700"
            style={{ left: `calc(50% + ${ropeOffset}px - 10px)`, boxShadow: '0 0 8px rgba(0,0,0,0.3)' }}
          >
            <div className="h-10 w-1 bg-amber-800 rounded-full" />
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
